var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"h-full flex justify-center items-center"},[_c('div',[_c('div',[_vm._v("メールアドレスが変更されました。")]),_c('div',{staticClass:"mt-4"},[_c('v-btn',{attrs:{"color":"primary","elevation":"0","block":""},on:{"click":function($event){_vm.$router.push('/setting').catch(() => {})}}},[_vm._v(" 戻る ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }